
import { KubaExportModule } from './../shared/kuba-exports/kuba-export.module';
import {
    ContactTypeResolver  
} from './../contact/services/contact.resolver.service';
import { ContactServices } from './../contact/services/contact.service';
import { KubaNorgeAsComponent } from './components/kuba-norge-as.component';
import { NewEditorContactComponent } from './components/new-editorcontacts.component';
import {
    EditorContactsEditResolver,
    FunctionResolver,
    EditorContactListByBusinessResolver,
    KubaNorgeAsResolver,
    ContactBusinessDataResolver
} from './services/editorcontacts.services.resolver';
import { EditorContactsServices } from './services/editorcontacts.services';
import { EditorContactListComponent } from './components/editorcontact-list.component';
import { EditorContactsComponent } from './editorcontacts.component';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { AppSharedModule } from './../shared/appShared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { PasswordValidatorModule } from 'src/app/shared/password-validator/password-validator.module';
@NgModule({ exports: [
        EditorContactsComponent,
        EditorContactListComponent,
        KubaNorgeAsComponent,
        NewEditorContactComponent
    ],
    declarations: [
        EditorContactsComponent,
        EditorContactListComponent,
        KubaNorgeAsComponent,
        NewEditorContactComponent
    ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AppSharedModule,
        RouterModule,
        TranslatePipe, TranslateDirective,
        KubaExportModule,
        PasswordValidatorModule
    ],
    providers: [
        EditorContactsServices,
        EditorContactsEditResolver,
        FunctionResolver,
        ContactTypeResolver,
        ContactServices,
        EditorContactListByBusinessResolver,
        KubaNorgeAsResolver,
        ContactBusinessDataResolver,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class EditorContactsModule { }
